<template>
    <div class="row" v-if="show">
    <div class="col s12 m12 l12">
            <div class="card card-loading">
                <div class="card-content">
                    <p>{{message}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import './ContainerAlert.scss';
</style>

<script>
export default{
    name: 'ContainerAlert',
    props:{
        message: {
            type: String,
            default: "",
            required: true,
        },
        show: {
            type: Boolean,
            default: false,
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/common/ContainerAlert/ContainerAlert.vue